import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const FadeUp = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, dark = false, className = "" }) => (
  <FadeUp className={`max-w-3xl ${className}`}>
    <p className={`font-mono text-xs font-semibold uppercase tracking-[0.25em] ${dark ? "text-sky-300" : "text-safety"}`}>
      {eyebrow}
    </p>
    <h2
      className={`mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-[2.75rem] lg:leading-[1.12] ${
        dark ? "text-white" : "text-slate-900"
      }`}
    >
      {title}
    </h2>
    {sub && <p className={`mt-4 text-base leading-relaxed ${dark ? "text-white/60" : "text-slate-600"}`}>{sub}</p>}
  </FadeUp>
);

export const Counter = ({ to, suffix = "", className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let rafId;
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      setVal(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [inView, to]);

  return (
    <span ref={ref} className={className}>
      {val.toLocaleString("en-IN")}
      {suffix}
    </span>
  );
};
